import { render, staticRenderFns } from "./InstallationFeatures.vue?vue&type=template&id=61add93e&scoped=true"
import script from "./InstallationFeatures.vue?vue&type=script&lang=js"
export * from "./InstallationFeatures.vue?vue&type=script&lang=js"
import style0 from "./InstallationFeatures.vue?vue&type=style&index=0&id=61add93e&prod&lang=scss"
import style1 from "./InstallationFeatures.vue?vue&type=style&index=1&id=61add93e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61add93e",
  null
  
)

export default component.exports